module.exports = __webpack_public_path__ + "8af6f0cc1a7c0de7f8e3ecedeaa968be.gif";